import { render, staticRenderFns } from "./applyParts.vue?vue&type=template&id=2dce5f2c&scoped=true&"
import script from "./applyParts.vue?vue&type=script&lang=js&"
export * from "./applyParts.vue?vue&type=script&lang=js&"
import style0 from "./../Setting/setting.less?vue&type=style&index=0&prod&lang=less&"
import style1 from "./applyParts.vue?vue&type=style&index=1&id=2dce5f2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce5f2c",
  null
  
)

export default component.exports